export default "__VITE_ASSET__0425d43e__"